import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/utils/classnames";
import "./index.css";

const buttonVariants = cva(
  "inline-flex items-center justify-center active:scale-90 whitespace-nowrap px-[15px] rounded-[7px] font-medium transition-all disabled:pointer-events-none disabled:opacity-35 [&_svg]:pointer-events-none shrink-0 [&_svg]:shrink-0 outline-none",
  {
    variants: {
      variant: {
        default:
          "btn-default",
        primary:
          "btn-primary",
        danger:
          "btn-danger",
        warning:
          "btn-warning",
        success:
          "btn-success",
        cancel:
          "btn-cancel",
      },
      size: {
        default: "h-[40px] text-s font-bold",
        sm: "h-[32px] text-xs font-bold",
        lg: "h-10 px-6 font-bold",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

function Button({
  className,
  variant,
  size,
  loading = false,
  asChild = false,
  children,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
    loading?: boolean;
  }) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({
        variant, size, className
      }),
        !asChild && !props.disabled ? 'active:scale-90' : '')}
      {...props}
    >
      {children}
      {
        loading &&
        <div className="flex gap-1 pl-1 text-base">
          <span className="animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
        </div>
      }
    </Comp>
  );
}

export { Button, buttonVariants };
